<div class="wrapper" *ngIf="trendingstory?.data">
  <div class="banner-wrapper" *ngIf="config?.theme.match('v1')">
    <div class="content">
      <div class="icon">
        <img class="bene-img" loading="lazy" src="../assets/images/default-campaign-picture.jpg" [attr.data-src]="trendingstory?.data?.media_beneficiary?.cdn_path"  alt="">
        <img class="heart" loading="lazy" [attr.data-src]="'../assets/images/heartfilled.png'" alt="">
      </div>
      <div class="para">{{trendingstory?.data?.title}}</div>
    </div>
    <div class="button" (click)="redirect(this.trendingstory?.data?.custom_tag)">Save {{trendingstory?.data?.beneficiaryname?.info_1.split(' ')[0]}} <i class="material-icons">chevron_right</i></div>
  </div>

  <div class="button" (click)="redirect(this.trendingstory?.data?.custom_tag)" *ngIf="config?.theme.match('v2')">Save {{trendingstory?.data?.beneficiaryname?.info_1.split(' ')[0]}} <i class="material-icons">chevron_right</i></div>
</div>